<script lang="ts">
  import type { Order } from "../../@types/api";
  import type { Category } from "../../@types/component";
  import { InfiniteScroll, NavBar } from "../components";
  import { loading } from "../store";
  import { getAttribute } from "../utils";
  import type { APIResponse } from "../utils";

  const isCopyable = navigator.clipboard;
  export let hideNavbar = false;

  const copy = (text: string) => {
    if (isCopyable) {
      navigator.clipboard.writeText(text);
    }
  };

  export let category: Category;
  export let getOrders: (_: any) => Promise<APIResponse<Order>>;
  export let onHistoryClick = (e: Event) => {
    const data = getAttribute(e, "data-item");
    if (data) {
      const order: Order = JSON.parse(data);
      const condition = category === "TELECOMMUNICATION" || category === "IDD";
      if (order.status !== "COMPLETED" && condition) {
        window.TawkAPI?.toggle && window.Tawk_API.toggle();

        window.Tawk_API?.setAttributes && window.Tawk_API.setAttributes({
          "Reference": order.referenceId || "N/A",
          "Transaction": order.transactionId || "N/A",
          "Order": order.id,
        });
      } else if (!condition) {
        params.set("orderId", order.id);
        window.location.search = params.toString();
      }
    }
  };

  const params = new URLSearchParams(location.search);
  let orders: Order[] | null = null;
  let ordersCursor: string | null = null;

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];


  getOrders && getOrders({ cursor: ordersCursor || "", category }).then(({ items, cursor }) => {
    orders = items;
    ordersCursor = cursor;
  }).finally(() => {
    loading.set(false);
  });

  const fetchOrders = ({ detail }: CustomEvent<{ loaded: () => void; completed: () => void }>) => {
    if (orders === null || ordersCursor) {
      getOrders && getOrders({ cursor: ordersCursor || "", category })
        .then(({ items, cursor }) => {
          orders = orders ? [...orders, ...items] : items;
          ordersCursor = cursor;
          if (cursor) {
            detail.loaded();
          } else {
            detail.completed();
          }
        })
        .catch(() => detail.completed());
    }
  };


  const formatStatus = (status: string): string => {
    if (status === "COMPLETED") return "Success";
    return status.charAt(0).toUpperCase() + status.substr(1).toLowerCase();
  };

  const formatDate = (date: string): string => {
    const formattedDate = new Date(
      new Date(date).toLocaleDateString("en-US", {
        timeZone: "Asia/Kuala_Lumpur",
      }),
    );
    return `${formattedDate.getDate().toString().padStart(2, "0")} ${
      months[formattedDate.getMonth()]
    } ${formattedDate.getFullYear()}`;
  };
</script>

{#if !hideNavbar}
  <NavBar onBack={() => (location.href = `https://${location.hostname}`)} title="Order History"/>
{/if}

<div style="height: 1000px">
  {#if orders}
    {#if orders.length > 0}
      <ul class="history-content__container" on:click={onHistoryClick}>
        {#each orders as history, i (history.id)}
          <li class="history-content__wrapper" data-item={JSON.stringify(history)}>
            <div class="history-content left">
              {#if category === "TELECOMMUNICATION"}
                <h2>Top-up - {history.name} RM{history.amount}</h2>
              {:else if category === "IDD" || category === "BILL"}
                <h2>{history.name}</h2>
              {:else}
                <h2>{history.category} - {history.operator}</h2>
              {/if}
              <div class="history-content__id" style="margin-bottom: 10px;">
                <div>Order ID:</div>
                <div style="display: flex;align-items: center;">
                  <span>
                    {history.id || "N/A"}
                  </span>
                  {#if isCopyable}
                    <svg style="margin-left: 5px;" width="18px" height="18px" fill="none" stroke="#a1a1a1" viewBox="0 0 24 24"
                         xmlns="http://www.w3.org/2000/svg">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"></path>
                    </svg>
                  {/if}
                </div>
              </div>
            </div>
            <div class="history-content right">
              <div>
                <div class="history-content__price">RM{history.payableAmount}</div>
                <div
                  class={`history-content__status ${formatStatus(
                  history.status
                ).toLowerCase()}`}
                >
                  {formatStatus(history.status)}
                </div>
                <div>{formatDate(history.createdAt)}</div>
              </div>
            </div>
          </li>
        {/each}
      </ul>
    {:else}
      <div class="empty">No orders found.</div>
    {/if}
    <InfiniteScroll on:infinite={fetchOrders}/>
  {/if}
</div>

<style lang="scss">
  .history-content__wrapper {
    display: flex;
    align-items: center;
    padding: 20px 15px;
  }

  .history-content__container > li + li {
    border-top: 1px solid #e0e0e0;
  }

  .history-content {
    color: #828282;

    div:not(.history-content__price) {
      font-size: 14px;
    }

    h2 {
      color: #333333;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 19px;
      margin-bottom: 8px;
    }

    &.left {
      flex: 1;
    }

    &.right {
      text-align: right;

      div {
        margin: 6px 0;
      }
    }

    &__price {
      color: #333333;
      font-weight: 600;
      font-size: 16px;
      line-height: 19px;
    }

    &__id > div:nth-child(2) {
      color: #333333;
    }

    &__status {
      &.success {
        color: #27ae60;
      }

      &.processing {
        color: #f2ce4a;
      }

      &.pending {
        color: #f2994a;
      }

      &.failed {
        color: #bb0000;
      }

      &.cancelled {
        color: #ff5a7c;
      }

      &.refunded {
        color: #4B0082;
      }
    }
  }

  .empty {
    font-size: 36px;
    text-align: center;
    padding: 50px 10px;
  }
</style>
